// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductEOQ extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK product */
  productId!: number;
  /** Int32 */
  eOQQty!: number;
  /** Decimal */
  projectedUsageQty?: number;
  /** Int32 */
  reorderPointQty!: number;
  /** FK productId */
  product!: Product;
}

